import '@fontsource/noto-nastaliq-urdu/400.css';
import '@fontsource/noto-nastaliq-urdu/700.css';
import './styles.css';
import './gov.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ClinicianApp } from './clinician/ClinicianApp.tsx';
import { DashboardApp } from './dashboard/DashboardApp.tsx';
import { Home } from './Home.tsx';
import { KioskApp } from './kiosk/KioskApp.tsx';
import { BriefPage } from './pages/BriefPage.tsx';
import { DisplayPage } from './pages/DisplayPage.tsx';
import { MinistryPage } from './pages/MinistryPage.tsx';
import { ProposalPage } from './pages/ProposalPage.tsx';
import { ScopePage } from './pages/ScopePage.tsx';

createRoot(document.getElementById('root')!).render(
  // No StrictMode: kiosk steps drive hardware (printer, devices) from effects, which must run once.
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/scope" element={<ScopePage />} />
      <Route path="/ministry" element={<MinistryPage />} />
      <Route path="/proposal" element={<ProposalPage />} />
      <Route path="/display" element={<DisplayPage />} />
      <Route path="/brief" element={<BriefPage />} />
      <Route path="/kiosk" element={<KioskApp />} />
      <Route path="/clinician" element={<ClinicianApp />} />
      <Route path="/dashboard" element={<DashboardApp />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>,
);
